export default __webpack_public_path__ + "static/evet-5b4f5935f63ee01ca7301c098330a737.webm";